/**
 * Shared helpers for the Play motion directives.
 *
 * Token-driven motion (see src/styles/tokens.scss → Motion). Every Play motion
 * directive/composable funnels through `prefersReducedMotion()` so the whole
 * layer honours the user's OS-level "reduce motion" setting in one place.
 */

/** True when the user asked the OS to minimise non-essential motion. */
export function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

/** True on real pointer devices (skip cursor-driven flourishes on touch). */
export function hasFinePointer() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches
}
